<template>
  <validation-observer ref="simpleRules">
    <b-form>

      <!-- Appeal Reason -->
      <b-form-group
        v-if="!appeal.questionName"
        :label="$t('Appeal Reason')"
        label-for="mc-appeal-reason"
      >
        <validation-provider
          #default="{ errors }"
          name="Appeal Reason"
          rules="required"
        >
          <v-select
            id="vue-select-appeal-reason"
            v-model="appeal.appealReason"
            :options="appealReasonOptions"
            :placeholder="$t('Select...')"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-primary">{{ $t(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Description -->
      <b-form-group
        :label="$t('Description')"
        label-for="mc-description"
      >

        <validation-provider
          #default="{ errors }"
          name="Description"
          rules="required"
        >
          <b-form-textarea
            v-model="appeal.description"
            rows="10"
            :placeholder="$t('Description...')"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-primary">{{ $t(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>

    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BForm, BFormTextarea,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BForm,
    BFormTextarea,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    projectid: {
      type: [Number, String],
      required: true,
    },
    orjref: {
      type: [Number, String],
      required: true,
    },
    value: {
      type: Object,
      default: null,
    },
    appealReasonOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      defaultItem: {
        projectid: this.projectid,
        orjref: this.orjref,
        questionName: null,
        appealReason: true,
        description: null,
      },
      required,
    }
  },
  computed: {
    appeal: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value) {
          return this.value
        }
        return this.defaultItem
      },
    },
  },
  methods: {
    showError(message) {
      this.$swal({
        icon: 'error',
        title: this.$t('Error!'),
        text: this.$t(message || 'An error occurred.'),
        customClass: {
          confirmButton: 'btn btn-danger',
        },
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.$emit('loading', true)
          useJwt.axiosIns.post('project/appeal', this.appeal)
            .then(response => {
              if (response.data && response.data.success === false) {
                this.showError(response.data.message)
                return
              }
              if (response.data) {
                this.$emit('submit')
              }
            })
            .catch(e => {
              console.log(e)
              const errorMessage = e.response && e.response.data && e.response.data.message
              this.showError(errorMessage || e.message)
            })
            .finally(() => {
              this.$emit('loading', false)
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
